(function() {
  if (window.CustomAjaxAddToCart && window.CustomAjaxAddToCart.initialized) {
    return;
  }

  var formSelector = '.custom-ajax-atc-form';
  var buttonSelector = '.custom-ajax-atc-button';

  window.CustomAjaxAddToCart = window.CustomAjaxAddToCart || {};
  window.CustomAjaxAddToCart.initialized = true;

  function getPageContainer() {
    return document.getElementById('PageContainer');
  }

  function getCartAction() {
    var pageContainer = getPageContainer();
    return pageContainer && pageContainer.dataset.cartAction ? pageContainer.dataset.cartAction : 'added';
  }

  function getLanguageUrl() {
    var pageContainer = getPageContainer();
    var languageUrl = pageContainer && pageContainer.dataset.languageUrl ? pageContainer.dataset.languageUrl : '';
    return !languageUrl || languageUrl === '/' ? '' : languageUrl;
  }

  function getErrorMessage(error) {
    if (error && error.description) {
      return error.description;
    }

    if (error && error.message) {
      return error.message;
    }

    return 'Error';
  }

  function getAddToCartUrl(form, button) {
    if (button && button.dataset.addUrl) {
      return button.dataset.addUrl;
    }

    if (form.dataset.ajaxAtcUrl) {
      return form.dataset.ajaxAtcUrl;
    }

    var action = form.getAttribute('action') || '/cart/add';

    try {
      var url = new URL(action, window.location.origin);

      if (!url.pathname.endsWith('.js')) {
        url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      }

      return url.pathname + url.search;
    } catch (error) {
      if (action.indexOf('.js') !== -1) {
        return action;
      }

      return action.replace(/\/?$/, '.js');
    }
  }

  function getCartForTheme() {
    return fetch(getLanguageUrl() + '/cart?view=compare', {
      credentials: 'same-origin'
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Unable to update cart drawer');
      }

      return response.json();
    });
  }

  function updateCartAfterAdd(button) {
    if (window.SLIDECART_UPDATE || window.SLIDECART_OPEN) {
      if (window.SLIDECART_UPDATE) {
        window.SLIDECART_UPDATE();
      }

      if (window.SLIDECART_OPEN) {
        window.SLIDECART_OPEN();
      }

      return Promise.resolve();
    }

    if (window.wetheme && (typeof window.wetheme.toggleRightDrawer === 'function' || typeof window.wetheme.updateCartDrawer === 'function')) {
      return getCartForTheme().then(function(cart) {
        if (getCartAction() === 'drawer' && typeof window.wetheme.toggleRightDrawer === 'function') {
          window.wetheme.toggleRightDrawer('cart', true, { cart: cart });
        } else if (typeof window.wetheme.updateCartDrawer === 'function') {
          window.wetheme.updateCartDrawer(cart);
        }
      });
    }

    window.location.href = button && button.dataset.cartUrl ? button.dataset.cartUrl : '/cart';
    return Promise.resolve();
  }

  function getAddToCartPayload(form) {
    var formData = new FormData(form);
    var variantId = Number(formData.get('id'));
    var quantity = Number(formData.get('quantity')) || 1;
    var sellingPlan = formData.get('selling_plan');
    var properties = {};

    if (!variantId) {
      return null;
    }

    var item = {
      id: variantId,
      quantity: quantity
    };

    formData.forEach(function(value, key) {
      var propertyMatch = key.match(/^properties\[(.+)\]$/);

      if (propertyMatch && value !== '') {
        properties[propertyMatch[1]] = value;
      }
    });

    if (sellingPlan) {
      item.selling_plan = sellingPlan;
    }

    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    return { items: [item] };
  }

  document.addEventListener('click', function(event) {
    if (!event.target || typeof event.target.closest !== 'function') {
      return;
    }

    var button = event.target.closest(buttonSelector);

    if (!button || button.disabled) {
      return;
    }

    var form = button.closest(formSelector);

    if (!form) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(button);
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }, true);

  document.addEventListener('submit', function(event) {
    if (!event.target || typeof event.target.closest !== 'function') {
      return;
    }

    var form = event.target.closest(formSelector);

    if (!form) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var button = form.querySelector(buttonSelector);
    var payload = getAddToCartPayload(form);

    if (!button || button.disabled || button.dataset.loading === 'true' || !payload) {
      return;
    }

    var defaultText = button.dataset.defaultLabel || button.textContent.trim();

    button.dataset.loading = 'true';
    button.disabled = true;
    button.textContent = button.dataset.loadingLabel || 'Adding...';

    fetch(getAddToCartUrl(form, button), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) {
            throw data;
          }

          return data;
        });
      })
      .then(function() {
        button.textContent = button.dataset.addedLabel || 'Added';
        return updateCartAfterAdd(button);
      })
      .catch(function(error) {
        console.error('Custom Ajax add to cart error:', error);
        button.textContent = getErrorMessage(error);
      })
      .finally(function() {
        setTimeout(function() {
          delete button.dataset.loading;
          button.disabled = false;
          button.textContent = defaultText;
        }, 1200);
      });
  }, true);
})();
